import React from 'react';

import PropTypes from 'prop-types';
import Select from '@tds/core-select';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import { orderStatus } from '../../../../../utils/constant';

const FilterByStatus = ({ filters, setFilters, includeIncompleteStatus }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByStatus, statusPlaceholder, statusFiltersIot }
  } = localizedStrings;
  const { incomplete } = orderStatus;

  let statusList = statusFiltersIot;

  if (!includeIncompleteStatus)
    statusList = statusList.filter(item => item.value !== incomplete);

  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-status' }}>
      <Select
        label={filterByStatus}
        placeholder={statusPlaceholder}
        options={statusList}
        defaultValue=""
        value={filters.status}
        onChange={e => setFilters({ ...filters, status: e.target.value })}
      />
    </div>
  );
};

FilterByStatus.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired,
  includeIncompleteStatus: PropTypes.bool.isRequired
};

export default FilterByStatus;
